module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (!_vm.deleted) ? _vm._c('div', {
    staticClass: "comment"
  }, [_vm._c('div', {
    staticClass: "avatar"
  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('i', {
    staticClass: "fas fa-user-circle"
  }) : _vm._c('img', {
    attrs: {
      "src": "/static/img/avatar.png",
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "body"
  }, [_vm._c('div', {
    staticClass: "head"
  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('strong', [_vm._v(_vm._s(_vm.comment.user_first_name) + " " + _vm._s(_vm.comment.user_last_name))]) : _vm._c('strong', [_vm._v("You")]), _vm._v(" "), _vm._c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.friendlyDate))]), _vm._v(" "), (_vm.showDelete) ? _vm._c('button', {
    staticClass: "btn btn-danger btn-sm pull-right",
    on: {
      "click": function($event) {
        _vm.deleteComment()
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v("   Delete")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
    staticClass: "text"
  }, [_vm._c('strong', [_vm._v("\"")]), _vm._v(_vm._s(_vm.comment.body)), _vm._c('strong', [_vm._v("\"")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27dcf1a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/blog/BlogComment.vue
// module id = 638
// module chunks = 1